/* Soerra — compatibilité des widgets (anciennement écrits pour Impulse) avec Dawn.
   - Un widget qui écrit l'ID de variante dans input[name="id"] et déclenche "change" :
     on réactive l'input et on fait suivre la galerie (media-gallery.setActiveMedia). */
(function () {
  function basculerMedia(id) {
    var carte = window.soerraVariantMedia || {};
    var mediaId = carte[String(id)];
    var pi = document.querySelector('product-info');
    var mg = document.querySelector('media-gallery');
    if (!mediaId || !pi || !mg || typeof mg.setActiveMedia !== 'function') return;
    mg.setActiveMedia(pi.dataset.section + '-' + mediaId, false);
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'INPUT' || el.name !== 'id') return;
    var f = el.form || el.closest('form');
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    el.disabled = false;
    basculerMedia(el.value);
  }, true);
})();
